module.exports = __webpack_public_path__ + "img/case-Exhibition-img2.b071e0a4.png";